import PayloadList from "./payload-list.jsx";
import {FaClock} from "react-icons/fa";
import {FaCircleUser} from "react-icons/fa6";
import {navigateHook} from "../../../../../hooks/use-navigate.js";


const ReportDetailedContent = ({ data }) => {

    const navigate = navigateHook();

  const parsePayload = (payloadString) => {
    try {
      return JSON.parse(payloadString);
    } catch (e) {
      return { invalid: "FORMATO INVÁLIDO" };
    }
  };

  return (
    <>
      <table id="audit-detailed-table" className="table report-table mt-[12px]!" sheet-name="Auditoria Detalhada">
        <tbody>
        {data && Array.isArray(data) && data.length > 0 ? (
          data?.map((item, idx) => {
            const payload = parsePayload(item.payload);
            return (
              <tr key={idx} className="border-b border-gray-300 bg-white">
                <td>
                  <div className="flex gap-1 text-sm items-center">
                    <span className="flex items-center gap-1"><FaClock/>{item.date_time}</span>
                    <span>|</span>
                    <span className="flex items-center gap-1 font-bold"><FaCircleUser/>{item.user_name}</span>
                    <span>|</span>
                    <span>{item.application}</span>
                    <span>|</span>
                    <span>{item.action}</span>
                    {item.solicitation && (
                      <>
                        <span>|</span>
                        <span>
                          Solicitação:{" "}

                          <a onClick={() => navigate(`/ecap-solicitation/form/${item.solicitation}`, true)}
                            target="_blank"
                            rel="noopener noreferrer" style={{color: "#337ab7", cursor: "pointer"}}
                          >
                            {item.solicitation}
                          </a>
                        </span>
                      </>
                    )}
                  </div>

                  <div>
                    <PayloadList payload={payload} />
                  </div>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td className="text-center text-gray-500">Nenhum dado encontrado</td>
          </tr>
        )}
        </tbody>
      </table>
      <div id="chart-tables"></div>
    </>
  );
};

export default ReportDetailedContent;